import React, { useEffect } from 'react';
import { Badge, Grid, Paper, Table, Tooltip } from '@mui/material';
import { useFamilyNameList } from '../../fetch/fetchClassificationItems';
import { useModelEmi } from '../../fetch/engineModelFetch';
import { preloadFaultList, useFaultList } from '../../fetch/fetchFault';
import { preloadVesselInfo, useOpenRecallCounts } from '../../fetch/fetchVesselInfo';
import { useNavigate } from 'react-router-dom';
import { logEngineModelSearch, logEngineSerialSearch, logFeatureUsage } from '../../fetch/insightsHelper';

export default function SerialNumberMatchNode({ serialMatch }) {
    const navigate = useNavigate();
    const { familyNames } = useFamilyNameList();
    const { data: emiData, isLoading } = useModelEmi(serialMatch.modelNum);
    const family = familyNames.filter(it => it.id == serialMatch.familyNameId)[0];
    const { totalRecords: faultCount } = useFaultList({ familyNameId: serialMatch?.familyNameId, skip: 0, take: 10 });
    const { data: openRecallCounts } = useOpenRecallCounts(serialMatch?.engineSerial);

    useEffect(() => {
        if (!!serialMatch?.engineSerial && !isLoading) {
            preloadVesselInfo(serialMatch?.engineSerial, 'en');
        }
    }, [isLoading])


    useEffect(() => {
        if (!!serialMatch?.engineSerial) {
            logFeatureUsage('EngineSerialNumberSearch');
            logEngineSerialSearch(serialMatch?.engineSerial, serialMatch?.modelNum);
        } else if (!!serialMatch?.modelNum && !serialMatch?.engineSerial) {
            logFeatureUsage('EngineModelNumberSearch');
            logEngineModelSearch(serialMatch?.modelNum);
        }
    }, [serialMatch?.engineSerial, serialMatch?.modelNum]);

    return (
        <Grid item xs={12} md={6}>
            <Paper
                sx={{
                    p: 1.5,
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100%',
                    overflow: 'hidden',
                    cursor: 'pointer'
                }}
            >
                {!!emiData && !isLoading ? (
                    <Table>
                        <tbody>
                            {!!emiData?.productName ? (
                                <tr>
                                    <th colSpan={2} style={{ textAlign: 'left' }}>{`${emiData.brand} ${emiData.productName}`}</th>
                                </tr>
                            ) : null}
                            {!!serialMatch.engineSerial ? (
                                <tr>
                                    <th style={{ textAlign: 'left' }}>
                                        Serial Number
                                    </th>
                                    <td style={{ textAlign: 'left' }}>
                                        {serialMatch.engineSerial}
                                    </td>
                                </tr>
                            ) : null}
                            {!!serialMatch.engineSerial ? (
                                <tr>
                                    <th style={{ textAlign: 'left' }}>
                                    </th>
                                    <td style={{ textAlign: 'left' }}>
                                        <a href={`/literature/engine/${serialMatch?.engineSerial}/`}>Engine Info</a>
                                        {!!openRecallCounts?.openBulletinCount ? (
                                            <Tooltip title={openRecallCounts?.openBulletinCount > 1 ? `${openRecallCounts?.openBulletinCount} Open Recalls` : `${openRecallCounts?.openBulletinCount} Open Recall`}>
                                                <Badge
                                                    badgeContent={openRecallCounts?.openBulletinCount}
                                                    color="error"
                                                    style={{ marginLeft: '1em' }}
                                                    aria-label={openRecallCounts?.openBulletinCount > 1 ? `${openRecallCounts?.openBulletinCount} Open Recalls` : `${openRecallCounts?.openBulletinCount} Open Recall`}
                                                    onClick={() => {
                                                        navigate(`/literature/engine/${serialMatch?.engineSerial}/?tab=history`);
                                                    }}
                                                />
                                            </Tooltip>
                                        ) : null}
                                    </td>
                                </tr>
                            ) : null}
                            <tr>
                                <th style={{ textAlign: 'left' }}>
                                    Model Number
                                </th>
                                <td style={{ textAlign: 'left' }}>
                                    {serialMatch.modelNum}
                                </td>
                            </tr>
                            <tr>
                                <th style={{ textAlign: 'left' }}>
                                    Family
                                </th>
                                <td style={{ textAlign: 'left' }}>
                                    {family?.name}
                                </td>
                            </tr>
                            {faultCount > 0 ? (
                                <tr>
                                    <th style={{ textAlign: 'left' }}>
                                        Faults
                                    </th>
                                    <td style={{ textAlign: 'left' }}>
                                        <a href={`/literature/fault/${serialMatch?.familyNameId}/`} onMouseOver={() => preloadFaultList(0, { familyNameId: serialMatch?.familyNameId })}>Fault Lookup</a>
                                    </td>
                                </tr>
                            ) : null}
                        </tbody>
                    </Table>
                ) : null}
            </Paper>
        </Grid>
    );
}